import NewTrip from "./NewTrip";

export default NewTrip;
